// Header Action Types
export const SET_PROVIDER = 'SET_PROVIDER';
export const SET_WALLET_ADDRESS = 'SET_WALLET_ADDRESS';

// NFT Action Types
export const FETCH_NFTS_REQUEST = 'FETCH_NFTS_REQUEST';
export const FETCH_NFTS_SUCCESS = 'FETCH_NFTS_SUCCESS';
export const FETCH_NFTS_FAILURE = 'FETCH_NFTS_FAILURE';
export const SET_USER_NFTS = 'SET_USER_NFTS';
export const SET_FILTER = 'SET_FILTER';
